<template>
  <div class="container-fluid text-center d-inline">
    <a @click="GetData(true)" v-if="showInfo == false ? false : true">
      <i class="fad fa-info-circle hover-info" title="اطلاعات"></i>
    </a>
    <a @click="Delete()" v-if="IsDelete">
      <i class="fad fa-trash hover-danger mr-4" title="حذف"></i>
    </a>
    <a @click="Edit()" v-if="IsEdit">
      <i class="fad fa-pen hover-warning mr-4" title="ویرایش"></i>
    </a>
    <div class="" >
      <modal @Close="Modal = false" :InheritanceTheme="true" :IsFooter="false" :Size="'Md'" v-if="Modal">
        <template v-slot:body>
          <div class="container-fluid p-3">
            <h5>پیگیری وضعیت درخواست</h5>
            <hr />
            <bnp-grid :key="tableKey" :hasRowNum="false" :propsColumn="columns" :propsRows="rows" :Selectable="false" :action="false">
              <template slot="tblcomboGrp101VaziatName" slot-scope="props">
                <span v-if="props.props.tblcomboGrp101Vaziat == 1085232" class="text-danger">{{ props.props.tblcomboGrp101VaziatName }}</span>
                <span v-else-if="props.props.tblcomboGrp101Vaziat == 1085233" class="text-info">{{ props.props.tblcomboGrp101VaziatName }}</span>
                <span v-else-if="props.props.tblcomboGrp101Vaziat == 1085234" class="text-success">{{ props.props.tblcomboGrp101VaziatName }}</span>
                <span v-else>{{ props.props.tblcomboGrp101VaziatName }}</span>
              </template>
            </bnp-grid>
          </div>
        </template>
      </modal>
    </div>
    <!-- <div class="" v-else :key="tableKey">
      <span v-for="(detail, key) in rows" :key="key">
       <div class="text-lg-right text-center" >
        <small>{{detail.namFam }}</small> &nbsp; <small class="font-weight-bold float-lg-left text-center" :class="setTextColor(detail.tblcomboGrp101Vaziat)">[{{ detail.tblcomboGrp101VaziatName }}]</small>
       </div>
    </span>
    </div> -->
  </div>
</template>
<script>
import Modal from '@/pages/Modal/Modal.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
export default {
  components: { Modal, BnpGrid },
  data() {
    return {
      TblGrpIdUserRequested: 0,
      ApiAddress: '',
      tableKey: 0,
      Modal: false,
      rows: [],
      columns: [
        { name: 'tartib', label: 'مرحله', visibility: true },
        { name: 'namFam', label: ' تایید کننده', visibility: true },
        { name: 'dateTimeLastEdit', label: 'تاریخ تغییر', visibility: true },
        { name: 'description', label: 'نظر تایید کننده', visibility: true },
        { name: 'tblcomboGrp101VaziatName', label: 'وضعیت', visibility: true },
      ],
    }
  },
  props: ['RequestRow', 'ApiAction', 'IsSarparast', 'showInfo', 'IsDelete', 'IsEdit', 'FormAutomation', 'GetGrpUserInserted'],
  created() {
    if (this.GetGrpUserInserted && this.GetGrpUserInserted > 0) {
      var axios = { Method: 'Get', Action: 'ReportCartabl/GetGrp/?fk=' + this.GetGrpUserInserted, Arryfildvalue: null }
      this.$PostData(axios).then((result) => {
        if (result.grpId && result.grpId > 0) {
          this.TblGrpIdUserRequested = result.grpId
          this.GetData()
        }
      })
    }
  },
  methods: {
    GetData(OpenModal) {
      this.rows=[]
      let grp
      let fk = 0
      if (this.GetGrpUserInserted && this.GetGrpUserInserted > 0) {
        grp = this.TblGrpIdUserRequested
      } else {
        grp = this.IsSarparast && this.IsSarparast == true ? this.RequestRow.grpUserReq : this.$session.get('UserInfo').tblGrpId
      }
      this.IsSarparast && this.IsSarparast == true ? (fk = this.RequestRow.fkId) : (fk = this.RequestRow.id)
      var axios = { Method: 'Get', Action: 'SelProcessWorkflowList/?Id=' + fk + '&tblGrpId=' + grp, Arryfildvalue: null }
      this.$PostData(axios).then((result) => {
        this.rows = result.data
        this.tableKey++
        if (OpenModal) {
          this.Modal = true
        }
      })
    },

    Delete() {
      let DataAxoisCheck = {
        ArryfildValue: { Id: this.RequestRow.fkId && this.RequestRow.fkId > 0 ? this.RequestRow.fkId : this.RequestRow.id },
        Method: 'Get',
        Action: 'Cartabl/AccessEditForm',
        Token: this.$session.get('Token'),
        From: 'Header',
      }
      this.$GetData_Header(DataAxoisCheck).then((data) => {
        if (data.status == 'success') {
          let DataAxiosDelete = {
            ArryfildValue: '',
            Method: 'Delete',
            Action: '',
            Token: this.$session.get('Token'),
          }
          if (this.RequestRow.tblFormAutomationId && this.RequestRow.tblFormAutomationId > 0) {
            this.$FindTableNameOnAutomationCartabl(this.RequestRow.tblFormAutomationId).then((res) => {
              DataAxiosDelete.Action = res
            })
          } else {
            console.log('😎 ~ this.$GetData_Header ~ this.FormAutomation:', this.FormAutomation)
            DataAxiosDelete.Action = this.FormAutomation
          }
          let Sweet = ['حذف اطلاعات', 'آیا از حذف این اطلاعات اطمینان دارید ؟', 'warning', false]
          this.$store.state.OldDataForLog = JSON.stringify(this.RequestRow)
          DataAxiosDelete.ArryfildValue = { id: this.RequestRow.id }
          this.$DeleteDatapropmise(DataAxiosDelete, Sweet).then((result) => {
            if (result == true) {
              this.$emit('Success', true)
            }
          })
        } else {
          this.$toasted.error(data.msg, { duration: 3500 })
        }
      })
    },
    Edit() {
      let DataAxoisCheck = {
        ArryfildValue: { Id: this.RequestRow.fkId && this.RequestRow.fkId > 0 ? this.RequestRow.fkId : this.RequestRow.id },
        Method: 'Get',
        Action: 'Cartabl/AccessEditForm',
        Token: this.$session.get('Token'),
        From: 'Header',
      }
      this.$GetData_Header(DataAxoisCheck).then((data) => {
        if (data.status == 'success') {
          this.$emit('DataEdit', this.RequestRow)
        } else {
          this.$toasted.error(data.msg, { duration: 3500 })
        }
      })
    },
    setTextColor(tblcomboGrp101Vaziat){
            if (tblcomboGrp101Vaziat==1085232) {
                return 'text-danger'
            }
            if (tblcomboGrp101Vaziat==1085233) {
                return 'text-warning'
            }
            if (tblcomboGrp101Vaziat==1085234) {
                return 'text-success'
            }
        }
  },
}
</script>
<style scoped>
.text-success {
  color: #79b30d !important;
}
</style>
